export default "__VITE_ASSET__BFcp6oWY__"